(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_custom-header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('.header__drawer header-drawer a[href]');
    if (!(link instanceof HTMLAnchorElement) || link.hasAttribute('download')) return;
    if (link.target && link.target !== '_self') return;
    if (link.origin !== location.origin || link.pathname !== location.pathname || link.search !== location.search) return;
    if (!link.hash) return;

    let targetId;
    try {
      targetId = decodeURIComponent(link.hash.slice(1));
    } catch {
      return;
    }
    if (!document.getElementById(targetId)) return;

    // Keep native anchor scrolling, and let Horizon release the drawer's lock and focus trap.
    const drawer = link.closest('header-drawer');
    if (drawer?.isOpen) drawer.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-article-toc"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var toc = document.getElementById('article-toc-list');
    if (!toc) return;

    var section = toc.closest('.section');
    if (!section) return;

    var rte = section.querySelector('.rte');
    if (!rte) return;

    var headings = rte.querySelectorAll('h2');
    if (!headings.length) return;

    var slugUsed = {};
    function slugify(text) {
      return text
        .toLowerCase()
        .replace(/[‘’]/g, "'")
        .replace(/[“”]/g, '"')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    var frag = document.createDocumentFragment();
    headings.forEach(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent) || 'section';
        var slug = base;
        var n = 2;
        while (slugUsed[slug] || document.getElementById(slug)) {
          slug = base + '-' + n++;
        }
        h.id = slug;
      }
      slugUsed[h.id] = true;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      frag.appendChild(li);
    });
    toc.appendChild(frag);

    var bar = document.querySelector('.article-toc__progress-bar');
    var links = toc.querySelectorAll('a');

    function getHeaderHeight() {
      var header = document.getElementById('header-component');
      if (header) {
        var rect = header.getBoundingClientRect();
        if (rect.height > 0) return Math.round(rect.height);
      }

      var styles = window.getComputedStyle(document.body);
      var headerHeight = parseFloat(styles.getPropertyValue('--header-height'));
      return Number.isNaN(headerHeight) ? 70 : Math.round(headerHeight);
    }

    function getHeaderBottom() {
      var header = document.getElementById('header-component');
      if (header) {
        var rect = header.getBoundingClientRect();
        if (rect.bottom > 0) return Math.round(rect.bottom);
      }

      return getHeaderHeight();
    }

    function updateAnchorOffset() {
      document.documentElement.style.setProperty('--article-anchor-offset', getHeaderHeight() + 'px');
    }

    function getScrollOffset() {
      return getHeaderBottom() + 16;
    }

    function onScroll() {
      var scrollY = window.scrollY;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (bar) bar.style.width = Math.min(100, Math.round((scrollY / docH) * 100)) + '%';

      var active = null;
      var offset = getScrollOffset();
      for (var i = headings.length - 1; i >= 0; i--) {
        if (headings[i].getBoundingClientRect().top <= offset) {
          active = i;
          break;
        }
      }
      links.forEach(function (l, j) {
        l.classList.toggle('is-active', j === active);
      });
    }

    updateAnchorOffset();
    window.addEventListener('resize', updateAnchorOffset, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (window.location.hash) {
      var hash = window.location.hash.slice(1);
      try {
        hash = decodeURIComponent(hash);
      } catch (e) {
        // Keep the raw hash if it is not valid URI encoding.
      }

      var target = document.getElementById(hash);
      if (target) {
        requestAnimationFrame(function () {
          target.scrollIntoView({ block: 'start' });
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-form-info-request"] && !Shopify.designMode) return;
  try {
    (function() {
    var form = document.getElementById('basin-info-request');
    if (!form) return;

    var submitBtn = form.querySelector('.basin-form__submit');
    var errorSummary = document.getElementById('basin-error-summary');
    var errorList = document.getElementById('basin-error-list');
    var successMsg = document.getElementById('basin-success');

    var fields = [
      { id: 'basin-first-name', msg: 'Please enter your first name.', label: 'First Name' },
      { id: 'basin-last-name', msg: 'Please enter your last name.', label: 'Last Name' },
      { id: 'basin-email', msg: 'Please enter a valid email address.', label: 'Email' },
      { id: 'basin-phone', msg: 'Please enter a valid phone number (e.g. (555) 555-5555).', label: 'Phone' },
      { id: 'basin-reason', msg: 'Please let us know what brings you here.', label: 'What brings you here' },
      { id: 'basin-message', msg: 'Please enter your question or message.', label: 'Questions' }
    ];

    function clearErrors() {
      fields.forEach(function(f) {
        var input = document.getElementById(f.id);
        var error = document.getElementById(f.id + '-error');
        if (input) {
          input.removeAttribute('aria-invalid');
        }
        if (error) error.setAttribute('aria-hidden', 'true');
      });
      errorSummary.classList.remove('is-visible');
      errorList.innerHTML = '';
    }

    function validateField(field) {
      var input = document.getElementById(field.id);
      if (!input) return true;

      var value = input.value.trim();
      var valid = true;

      if (input.hasAttribute('required') && !value) {
        valid = false;
      } else if (input.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        valid = false;
      } else if (input.type === 'tel' && value && !/^\+?1?\s*[-.\s(]*\d{3}[-.\s)]*\d{3}[-.\s]*\d{4}$/.test(value)) {
        valid = false;
      }

      var error = document.getElementById(field.id + '-error');
      if (!valid) {
        input.setAttribute('aria-invalid', 'true');
        if (error) error.setAttribute('aria-hidden', 'false');
      } else {
        input.removeAttribute('aria-invalid');
        if (error) error.setAttribute('aria-hidden', 'true');
      }

      return valid;
    }

    fields.forEach(function(f) {
      var input = document.getElementById(f.id);
      if (input) {
        input.addEventListener('blur', function() {
          validateField(f);
        });
        input.addEventListener('input', function() {
          if (input.getAttribute('aria-invalid') === 'true') {
            validateField(f);
          }
        });
      }
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      clearErrors();

      var errors = [];
      fields.forEach(function(f) {
        if (!validateField(f)) {
          errors.push(f);
        }
      });

      if (errors.length > 0) {
        errors.forEach(function(f) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + f.id;
          a.textContent = f.msg;
          a.addEventListener('click', function(ev) {
            ev.preventDefault();
            document.getElementById(f.id).focus();
          });
          li.appendChild(a);
          errorList.appendChild(li);
        });

        errorSummary.classList.add('is-visible');
        requestAnimationFrame(function() {
          var heading = errorSummary.querySelector('p[tabindex]');
          if (heading) {
            heading.focus();
            heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
        return;
      }

      try {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';

      var formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(function(response) {
        if (response.ok) {
          var firstNameEl = form.querySelector('input[name="first_name"]');
          var lastNameEl = form.querySelector('input[name="last_name"]');
          var emailEl = form.querySelector('input[name="email"]');
          var phoneEl = form.querySelector('input[name="phone"]');
          var reasonEl = form.querySelector('select[name="reason"]');
          var firstName = firstNameEl ? firstNameEl.value.trim() : '';
          var lastName = lastNameEl ? lastNameEl.value.trim() : '';
          var email = emailEl ? emailEl.value.trim().toLowerCase() : '';
          var phoneRaw = phoneEl ? phoneEl.value.trim() : '';
          var phoneDigits = phoneRaw.replace(/\D/g, '');
          var phoneE164 = phoneDigits.length === 10
            ? '+1' + phoneDigits
            : (phoneDigits.length === 11 ? '+' + phoneDigits : phoneRaw);

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'generate_lead',
            form_id: '0e1a4845aec6',
            form_name: 'info_request',
            lead_reason: reasonEl ? reasonEl.value : '',
            user_data: {
              email_address: email,
              phone_number: phoneE164,
              address: {
                first_name: firstName,
                last_name: lastName
              }
            }
          });
          form.reset();
          successMsg.classList.add('is-visible');
          requestAnimationFrame(function() {
            var heading = successMsg.querySelector('p[tabindex]');
            if (heading) {
              heading.focus();
              heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        } else {
          throw new Error('Submission failed');
        }
      })
      .catch(function() {
        errorList.innerHTML = '<li>Something went wrong. Please try again or contact us at <a href="mailto:drive@bactrack.com">drive@bactrack.com</a>.</li>';
        errorSummary.classList.add('is-visible');
        requestAnimationFrame(function() {
          var heading = errorSummary.querySelector('p[tabindex]');
          if (heading) {
            heading.focus();
          }
        });
      })
      .finally(function() {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send Message';
      });
      } catch (syncErr) {
        // fetch()/FormData can throw synchronously (CSP block, bad URL) before the
        // promise chain exists; restore the form instead of sticking on 'Sending...'.
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send Message';
        errorList.innerHTML = '<li>Something went wrong. Please try again or contact us at <a href="mailto:drive@bactrack.com">drive@bactrack.com</a>.</li>';
        errorSummary.classList.add('is-visible');
        requestAnimationFrame(function() {
          var heading = errorSummary.querySelector('p[tabindex]');
          if (heading) heading.focus();
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-form-location-lead"] && !Shopify.designMode) return;
  try {
    (function() {
    var form = document.getElementById('basin-location-lead');
    if (!form) return;

    var submitBtn = form.querySelector('.basin-form__submit');
    var errorSummary = document.getElementById('basin-location-lead-error-summary');
    var errorList = document.getElementById('basin-location-lead-error-list');
    var successMsg = document.getElementById('basin-location-lead-success');
    var submitLabel = form.dataset.submitLabel;
    var sendingLabel = form.dataset.sendingLabel;
    var failureMessage = form.dataset.failureMessage;
    var fields = [
      { id: 'basin-location-first-name' },
      { id: 'basin-location-last-name' },
      { id: 'basin-location-email' },
      { id: 'basin-location-phone' },
      { id: 'basin-location-zip' },
      { id: 'basin-location-deadline' }
    ];

    function clearErrors() {
      fields.forEach(function(field) {
        var input = document.getElementById(field.id);
        var error = document.getElementById(field.id + '-error');
        if (input) input.removeAttribute('aria-invalid');
        if (error) error.setAttribute('aria-hidden', 'true');
      });
      errorSummary.classList.remove('is-visible');
      errorList.innerHTML = '';
    }

    function validateField(field) {
      var input = document.getElementById(field.id);
      if (!input) return true;
      var value = input.value.trim();
      field.msg = input.dataset.errorMessage;
      var valid = true;
      if (input.hasAttribute('required') && !value) {
        valid = false;
      } else if (input.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        valid = false;
      } else if (input.type === 'tel' && value && !/^\+?1?\s*[-.\s(]*\d{3}[-.\s)]*\d{3}[-.\s]*\d{4}$/.test(value)) {
        valid = false;
      } else if (input.name === 'zip' && value && !/^\d{5}$/.test(value)) {
        valid = false;
      }
      var error = document.getElementById(field.id + '-error');
      if (!valid) {
        input.setAttribute('aria-invalid', 'true');
        if (error) error.setAttribute('aria-hidden', 'false');
      } else {
        input.removeAttribute('aria-invalid');
        if (error) error.setAttribute('aria-hidden', 'true');
      }
      return valid;
    }

    fields.forEach(function(field) {
      var input = document.getElementById(field.id);
      if (!input) return;
      input.addEventListener('blur', function() { validateField(field); });
      input.addEventListener('input', function() {
        if (input.getAttribute('aria-invalid') === 'true') validateField(field);
      });
    });

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      clearErrors();
      var errors = [];
      fields.forEach(function(field) {
        if (!validateField(field)) errors.push(field);
      });
      if (errors.length) {
        errors.forEach(function(field) {
          var listItem = document.createElement('li');
          var link = document.createElement('a');
          link.href = '#' + field.id;
          link.textContent = field.msg;
          link.addEventListener('click', function(clickEvent) {
            clickEvent.preventDefault();
            document.getElementById(field.id).focus();
          });
          listItem.appendChild(link);
          errorList.appendChild(listItem);
        });
        errorSummary.classList.add('is-visible');
        requestAnimationFrame(function() {
          var heading = errorSummary.querySelector('p[tabindex]');
          if (heading) heading.focus();
        });
        return;
      }

      try {
        submitBtn.disabled = true;
        submitBtn.textContent = sendingLabel;
        fetch(form.action, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function(response) {
            if (!response.ok) throw new Error('Submission failed');
            var phoneEl = form.querySelector('input[name="phone"]');
            var emailEl = form.querySelector('input[name="email"]');
            var firstNameEl = form.querySelector('input[name="first_name"]');
            var lastNameEl = form.querySelector('input[name="last_name"]');
            var deadlineEl = form.querySelector('select[name="deadline"]');
            var serviceCenterEl = form.querySelector('input[name="service_center"]');
            var phoneRaw = phoneEl ? phoneEl.value.trim() : '';
            var phoneDigits = phoneRaw.replace(/\D/g, '');
            var phoneE164 = phoneDigits.length === 10
              ? '+1' + phoneDigits
              : (phoneDigits.length === 11 ? '+' + phoneDigits : phoneRaw);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'generate_lead',
              form_id: '0e1a4845aec6',
              form_name: 'location_lead',
              lead_reason: 'court_dui',
              lead_deadline: deadlineEl ? deadlineEl.value : '',
              service_center: serviceCenterEl ? serviceCenterEl.value : '',
              user_data: {
                email_address: emailEl ? emailEl.value.trim().toLowerCase() : '',
                phone_number: phoneE164,
                address: {
                  first_name: firstNameEl ? firstNameEl.value.trim() : '',
                  last_name: lastNameEl ? lastNameEl.value.trim() : ''
                }
              }
            });
            form.reset();
            successMsg.classList.add('is-visible');
            requestAnimationFrame(function() {
              var heading = successMsg.querySelector('p[tabindex]');
              if (heading) heading.focus();
            });
          })
          .catch(function() {
            errorList.innerHTML = '';
            var listItem = document.createElement('li');
            listItem.textContent = failureMessage;
            errorList.appendChild(listItem);
            errorSummary.classList.add('is-visible');
          })
          .finally(function() {
            submitBtn.disabled = false;
            submitBtn.textContent = submitLabel;
          });
      } catch (syncErr) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitLabel;
        errorList.innerHTML = '';
        var listItem = document.createElement('li');
        listItem.textContent = failureMessage;
        errorList.appendChild(listItem);
        errorSummary.classList.add('is-visible');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-form-sms"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-sms-form]').forEach(function(form) {
      if (form.dataset.smsFormInit) return;
      form.dataset.smsFormInit = 'true';

      var btn = form.querySelector('.bd-sms-form__btn');
      var input = form.querySelector('input[name="phone"]');
      var errorEl = form.querySelector('.bd-sms-form__error');
      var successEl = form.querySelector('.bd-sms-form__success');
      var noteEl = form.querySelector('.bd-sms-form__note');
      var sourceInput = form.querySelector('input[name="source"]');
      var btnLabel = btn.textContent.trim();

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        errorEl.classList.remove('is-visible');

        var phone = input.value.trim();
        if (!phone || !/^\+?1?\s*[-.\s(]*\d{3}[-.\s)]*\d{3}[-.\s]*\d{4}$/.test(phone)) {
          input.style.borderColor = '#dc3545';
          errorEl.classList.add('is-visible');
          input.focus();
          return;
        }

        try {
        btn.disabled = true;
        btn.textContent = 'Sending...';

        fetch(form.action, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
        .then(function(res) {
          if (res.ok) {
            var phoneDigits = phone.replace(/\D/g, '');
            var phoneE164 = phoneDigits.length === 10
              ? '+1' + phoneDigits
              : (phoneDigits.length === 11 ? '+' + phoneDigits : phone);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'generate_lead',
              form_id: 'c202ab7a9c83',
              form_name: 'sms_lead_capture',
              source: sourceInput ? sourceInput.value : '',
              user_data: {
                phone_number: phoneE164
              }
            });
            form.querySelector('.bd-sms-form__row').style.display = 'none';
            if (noteEl) noteEl.style.display = 'none';
            successEl.classList.add('is-visible');
          } else {
            throw new Error('Failed');
          }
        })
        .catch(function() {
          btn.disabled = false;
          btn.textContent = btnLabel;
          errorEl.querySelector('p').textContent = 'Something went wrong. Please try again.';
          errorEl.classList.add('is-visible');
        });
        } catch (syncErr) {
          // fetch()/FormData can throw synchronously (CSP block, bad URL) before the
          // promise chain exists; restore the form instead of sticking on 'Sending...'.
          btn.disabled = false;
          btn.textContent = btnLabel;
          errorEl.querySelector('p').textContent = 'Something went wrong. Please try again.';
          errorEl.classList.add('is-visible');
        }
      });

      input.addEventListener('input', function() {
        input.style.borderColor = '';
        errorEl.classList.remove('is-visible');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-location-map"] && !Shopify.designMode) return;
  try {
    (function () {
    var PIN_SVG =
      '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="52" viewBox="0 0 44 52">' +
      '<path d="M22 50s16-15.2 16-28A16 16 0 0 0 6 22c0 12.8 16 28 16 28z" fill="#00A896" stroke="#ffffff" stroke-width="2.5"/>' +
      '<circle cx="22" cy="22" r="6" fill="#ffffff"/></svg>';
    var loading = null;

    function ensureMaps(key) {
      if (window.google && window.google.maps && window.google.maps.Map) return Promise.resolve(window.google.maps);
      if (loading) return loading;
      loading = new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
        var poll = function () {
          if (window.google && window.google.maps && window.google.maps.Map) return resolve(window.google.maps);
          setTimeout(poll, 100);
        };
        if (existing) return poll();
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly&loading=async';
        script.async = true;
        script.onload = poll;
        script.onerror = function () { reject(new Error('Google Maps failed to load')); };
        document.head.appendChild(script);
      });
      return loading;
    }

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function mount(el, maps) {
      if (el.dataset.mounted) return;
      el.dataset.mounted = 'true';
      var position = { lat: parseFloat(el.dataset.lat), lng: parseFloat(el.dataset.lng) };
      var map = new maps.Map(el, {
        center: position,
        zoom: parseInt(el.dataset.zoom, 10) || 14,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        gestureHandling: 'cooperative',
        clickableIcons: false
      });
      var marker = new maps.Marker({
        map: map,
        position: position,
        title: el.dataset.name,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(PIN_SVG),
          scaledSize: new maps.Size(44, 52),
          anchor: new maps.Point(22, 50)
        }
      });
      var content = document.createElement('div');
      content.className = 'custom-location-map__popup';
      content.innerHTML =
        '<span class="custom-location-map__popup-name">' + escapeHtml(el.dataset.name) + '</span>' +
        '<span class="custom-location-map__popup-place">' + escapeHtml(el.dataset.place) + '</span>' +
        (el.dataset.hours ? '<span class="custom-location-map__popup-hours">' + escapeHtml(el.dataset.hours) + '</span>' : '');
      var info = new maps.InfoWindow({ content: content, disableAutoPan: false });
      marker.addListener('click', function () { info.open({ map: map, anchor: marker }); });
      if (el.dataset.popup === 'true') {
        info.open({ map: map, anchor: marker });
      }
    }

    function init() {
      var targets = document.querySelectorAll('[data-location-map]:not([data-mounted])');
      if (!targets.length) return;
      var key = targets[0].dataset.key;
      ensureMaps(key).then(function (maps) {
        targets.forEach(function (el) { mount(el, maps); });
      }).catch(function () {
        targets.forEach(function (el) {
          var fallback = el.querySelector('noscript');
          if (fallback) el.innerHTML = fallback.textContent;
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-locations-finder"] && !Shopify.designMode) return;
  try {
    (function () {
    var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var MOBILE = window.matchMedia('(max-width: 989px)');
    var mapsLoading = null;

    function pinUrl(fill) {
      return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="52" viewBox="0 0 44 52">' +
        '<path d="M22 50s16-15.2 16-28A16 16 0 0 0 6 22c0 12.8 16 28 16 28z" fill="' + fill + '" stroke="#ffffff" stroke-width="2.5"/>' +
        '<circle cx="22" cy="22" r="6" fill="#ffffff"/></svg>'
      );
    }

    function loadMaps(key) {
      if (window.google && window.google.maps && window.google.maps.Map) return Promise.resolve(window.google.maps);
      if (mapsLoading) return mapsLoading;
      mapsLoading = new Promise(function (resolve, reject) {
        var poll = function () {
          if (window.google && window.google.maps && window.google.maps.Map) return resolve(window.google.maps);
          setTimeout(poll, 100);
        };
        if (document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) return poll();
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly&loading=async';
        script.async = true;
        script.onload = poll;
        script.onerror = function () { reject(new Error('maps')); };
        document.head.appendChild(script);
      });
      return mapsLoading;
    }

    function esc(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function miles(a, b) {
      var r = Math.PI / 180;
      var dLat = (b.lat - a.lat) * r;
      var dLng = (b.lng - a.lng) * r;
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * 3958.8 * Math.asin(Math.min(1, Math.sqrt(s)));
    }

    function fmtTime(t) {
      var p = String(t).split(':');
      var h = parseInt(p[0], 10);
      var m = p[1] || '00';
      var ap = h >= 12 ? 'pm' : 'am';
      h = h % 12 || 12;
      return h + (m === '00' ? '' : ':' + m) + ' ' + ap;
    }

    function openLine(hours, copy) {
      if (!hours) return null;
      var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
      var today = hours[DAYS[now.getDay()]];
      if (!today || !today.open || !today.close) return { text: copy.closedToday, closed: true };
      var mins = now.getHours() * 60 + now.getMinutes();
      var o = today.open.split(':');
      var c = today.close.split(':');
      var openM = parseInt(o[0], 10) * 60 + parseInt(o[1], 10);
      var closeM = parseInt(c[0], 10) * 60 + parseInt(c[1], 10);
      if (mins < openM) return { text: copy.opensAt + fmtTime(today.open), closed: false };
      if (mins >= closeM) return { text: copy.closedNow, closed: true };
      return { text: copy.openUntil + fmtTime(today.close), closed: false };
    }

    function initFinder(root) {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      var copy = {};
      try { copy = JSON.parse(root.querySelector('[data-locations-copy]').textContent); } catch (e) {}
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-shop]'));
      var groupsEl = root.querySelector('[data-locations-groups]');
      var flatEl = root.querySelector('[data-locations-flat]');
      var flatFirst = root.querySelector('[data-flat-first]');
      var flatRest = root.querySelector('[data-flat-rest]');
      var flatTitle = root.querySelector('[data-flat-next-title]');
      var summaryEl = root.querySelector('[data-locations-summary]');
      var resetEl = root.querySelector('[data-locations-reset]');
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-region-chip]'));
      var mapEl = root.querySelector('[data-locations-map]');
      var slotDesktop = root.querySelector('[data-map-slot-desktop]');
      var slotMobile = root.querySelector('[data-map-slot-mobile]');
      var state = { region: 'all', origin: null, label: '', active: null };

      var shops = rows.map(function (row, i) {
        var hours = null;
        if (row.dataset.hours) {
          try { hours = JSON.parse(row.dataset.hours); } catch (e) { hours = null; }
        }
        return {
          row: row,
          home: row.parentNode,
          order: i,
          handle: row.dataset.handle,
          region: row.dataset.region,
          lat: parseFloat(row.dataset.lat),
          lng: parseFloat(row.dataset.lng),
          city: row.dataset.city,
          name: row.dataset.name,
          url: row.dataset.url,
          hours: hours
        };
      });
      var byHandle = {};
      shops.forEach(function (s) { byHandle[s.handle] = s; });

      shops.forEach(function (s) {
        var line = openLine(s.hours, copy);
        var el = s.row.querySelector('[data-open]');
        if (line && el) {
          el.textContent = line.text;
          el.classList.toggle('is-closed', line.closed);
          el.hidden = false;
        }
      });

      function visible() {
        return shops.filter(function (s) { return state.region === 'all' || s.region === state.region; });
      }

      function sortedByDistance(list) {
        return list.slice().sort(function (a, b) { return miles(state.origin, a) - miles(state.origin, b); });
      }

      function count(n) {
        return '<strong>' + n + '</strong> ' + (n === 1 ? copy.shop : copy.shops);
      }

      function render() {
        var list = visible();
        var on = {};
        list.forEach(function (s) { on[s.handle] = true; });

        if (state.origin) {
          var sorted = sortedByDistance(list);
          shops.forEach(function (s) {
            s.row.classList.remove('is-closest');
            s.row.querySelector('[data-closest-badge]').hidden = true;
            s.row.querySelector('[data-closest-cta]').hidden = true;
          });
          sorted.forEach(function (s, i) {
            var d = miles(state.origin, s);
            var distEl = s.row.querySelector('[data-dist]');
            distEl.innerHTML = (d < 10 ? d.toFixed(1) : Math.round(d)) + ' <small>' + esc(copy.mi) + '</small>';
            distEl.hidden = false;
            (i === 0 ? flatFirst : flatRest).appendChild(s.row);
          });
          if (sorted.length) {
            var first = sorted[0].row;
            first.classList.add('is-closest');
            var badge = first.querySelector('[data-closest-badge]');
            badge.textContent = copy.closestTo + state.label;
            badge.hidden = false;
            first.querySelector('[data-closest-cta]').hidden = false;
          }
          flatTitle.innerHTML = esc(copy.nextClosest) + ' <span>' + Math.max(sorted.length - 1, 0) + ' ' + esc(copy.shops) + '</span>';
          flatTitle.hidden = sorted.length < 2;
          shops.forEach(function (s) { if (!on[s.handle]) s.row.hidden = true; else s.row.hidden = false; });
          groupsEl.hidden = true;
          flatEl.hidden = false;
          summaryEl.innerHTML = esc(copy.sortedFrom) + '<strong>' + esc(state.label) + '</strong>';
        } else {
          shops.slice().sort(function (a, b) { return a.order - b.order; }).forEach(function (s) {
            s.row.classList.remove('is-closest');
            s.row.querySelector('[data-closest-badge]').hidden = true;
            s.row.querySelector('[data-closest-cta]').hidden = true;
            s.row.querySelector('[data-dist]').hidden = true;
            s.row.hidden = !on[s.handle];
            s.home.appendChild(s.row);
          });
          root.querySelectorAll('[data-region-group]').forEach(function (g) {
            g.hidden = state.region !== 'all' && g.dataset.regionGroup !== state.region;
          });
          groupsEl.hidden = false;
          flatEl.hidden = true;
          summaryEl.innerHTML = count(list.length) + esc(state.region === 'all' ? copy.inCalifornia : copy.inRegion + (copy.regions[state.region] || ''));
        }
        resetEl.hidden = !(state.origin || state.region !== 'all');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.regionChip === state.region)); });
        syncPins(on);
        fitMap();
      }

      /* Map */
      var gm = null;
      var map = null;
      var info = null;
      var markers = {};
      var you = null;
      var pendingIdle = null;

      function pinIcon(active) {
        var w = active ? 40 : 30;
        var h = active ? 47 : 35;
        return { url: pinUrl(active ? '#0D1F3C' : '#00A896'), scaledSize: new gm.Size(w, h), anchor: new gm.Point(w / 2, h - 1) };
      }

      function openInfo(handle) {
        if (!map) return;
        var s = byHandle[handle];
        var line = openLine(s.hours, copy);
        var box = document.createElement('div');
        box.className = 'custom-locations-finder__popup';
        box.innerHTML =
          '<span class="custom-locations-finder__popup-name">' + esc(s.name) + '</span>' +
          '<span>' + esc(s.city) + ', CA</span>' +
          (line ? '<span class="custom-locations-finder__popup-hours">' + esc(line.text) + '</span>' : '') +
          '<a class="custom-locations-finder__popup-link" href="' + esc(s.url) + '" data-cta-name="locations_hub_map_card" data-cta-location="finder" data-destination-type="page">' + esc(copy.viewShop) + ' &rarr;</a>';
        info.setContent(box);
        info.open({ map: map, anchor: markers[handle], shouldFocus: false });
      }

      function syncPins(on) {
        if (!map) return;
        shops.forEach(function (s) {
          markers[s.handle].setOpacity(on[s.handle] ? 1 : 0.25);
          markers[s.handle].setZIndex(on[s.handle] ? 2 : 1);
        });
      }

      function setYou() {
        if (!map) return;
        if (you) { you.setMap(null); you = null; }
        if (!state.origin) return;
        you = new gm.Marker({
          map: map,
          position: { lat: state.origin.lat, lng: state.origin.lng },
          clickable: false,
          zIndex: 0,
          icon: { path: gm.SymbolPath.CIRCLE, scale: 8, fillColor: '#2563EB', fillOpacity: 1, strokeColor: '#ffffff', strokeWeight: 3 }
        });
      }

      function fitMap() {
        if (!map) return;
        var list = visible();
        if (!list.length) return;
        var closest = null;
        var points = list;
        if (state.origin) {
          var sorted = sortedByDistance(list);
          closest = sorted[0];
          points = sorted.slice(0, 3).concat([state.origin]);
        }
        var bounds = new gm.LatLngBounds();
        points.forEach(function (p) { bounds.extend({ lat: p.lat, lng: p.lng }); });
        info.close();
        if (pendingIdle) gm.event.removeListener(pendingIdle);
        pendingIdle = gm.event.addListenerOnce(map, 'idle', function () {
          pendingIdle = null;
          if (map.getZoom() > 12) map.setZoom(12);
          if (closest) openInfo(closest.handle);
        });
        map.fitBounds(bounds, 64);
        setTimeout(function () {
          if (pendingIdle) {
            gm.event.removeListener(pendingIdle);
            pendingIdle = null;
            if (closest) openInfo(closest.handle);
          }
        }, 1500);
      }

      function setActive(handle) {
        if (state.active && byHandle[state.active]) {
          byHandle[state.active].row.classList.remove('is-active');
          if (markers[state.active]) markers[state.active].setIcon(pinIcon(false));
        }
        state.active = handle;
        if (handle && byHandle[handle]) {
          byHandle[handle].row.classList.add('is-active');
          if (markers[handle]) {
            markers[handle].setIcon(pinIcon(true));
            markers[handle].setZIndex(5);
          }
        }
      }

      function placeMap() {
        if (!mapEl) return;
        var target = MOBILE.matches ? slotMobile : slotDesktop;
        if (mapEl.parentNode !== target) target.appendChild(mapEl);
        if (!MOBILE.matches) root.classList.remove('is-map-view');
        if (map) setTimeout(function () { gm.event.trigger(map, 'resize'); fitMap(); }, 60);
      }

      function setView(view) {
        root.classList.toggle('is-map-view', view === 'map');
        root.querySelectorAll('[data-locations-view]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.locationsView === view));
        });
        if (view === 'map' && map) setTimeout(function () { gm.event.trigger(map, 'resize'); fitMap(); }, 30);
      }

      if (mapEl && root.dataset.mapsKey) {
        loadMaps(root.dataset.mapsKey).then(function (maps) {
          gm = maps;
          map = new gm.Map(mapEl, {
            center: { lat: 36.6, lng: -119.6 },
            zoom: 6,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            gestureHandling: 'cooperative',
            clickableIcons: false
          });
          info = new gm.InfoWindow({ disableAutoPan: false });
          shops.forEach(function (s) {
            var marker = new gm.Marker({
              map: map,
              position: { lat: s.lat, lng: s.lng },
              title: s.city + ': ' + s.name,
              icon: pinIcon(false),
              optimized: false
            });
            marker.addListener('click', function () {
              openInfo(s.handle);
              setActive(s.handle);
            });
            markers[s.handle] = marker;
          });
          var on = {};
          visible().forEach(function (s) { on[s.handle] = true; });
          syncPins(on);
          setYou();
          fitMap();
        }).catch(function () {
          slotDesktop.hidden = true;
          var toggle = root.querySelector('[data-locations-toggle]');
          if (toggle) toggle.hidden = true;
          setView('list');
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          state.region = chip.dataset.regionChip;
          render();
        });
      });

      resetEl.addEventListener('click', function () {
        state.region = 'all';
        state.origin = null;
        state.label = '';
        setYou();
        render();
        document.dispatchEvent(new CustomEvent('drive:locations-reset'));
        var allChip = root.querySelector('[data-region-chip="all"]');
        if (allChip) allChip.focus();
      });

      root.querySelectorAll('[data-locations-view]').forEach(function (b) {
        b.addEventListener('click', function () { setView(b.dataset.locationsView); });
      });

      rows.forEach(function (row) {
        row.addEventListener('mouseenter', function () { setActive(row.dataset.handle); });
        row.addEventListener('mouseleave', function () { setActive(null); });
        row.addEventListener('focusin', function () { setActive(row.dataset.handle); });
        row.addEventListener('focusout', function () { setActive(null); });
      });

      document.addEventListener('drive:locations-origin', function (event) {
        var d = event.detail || {};
        if (isNaN(d.lat) || isNaN(d.lng)) return;
        state.origin = { lat: d.lat, lng: d.lng };
        state.label = d.label || '';
        state.region = 'all';
        setYou();
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      MOBILE.addEventListener('change', placeMap);
      placeMap();
    }

    function initAll() {
      document.querySelectorAll('[data-locations-finder]').forEach(initFinder);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-locations-search"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSearch(form) {
      if (!form || form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      var input = form.querySelector('input[name="zip"]');
      var statusEl = form.querySelector('[data-locations-status]');
      var geoBtn = form.querySelector('[data-locations-geo]');
      var copy = {};
      try {
        copy = JSON.parse(form.querySelector('[data-locations-search-copy]').textContent);
      } catch (e) {}

      function setStatus(text, isError) {
        statusEl.textContent = text || '';
        statusEl.classList.toggle('is-error', !!isError);
        input.setAttribute('aria-invalid', isError ? 'true' : 'false');
      }

      function announce(lat, lng, label) {
        setStatus((copy.showing || '') + label, false);
        document.dispatchEvent(new CustomEvent('drive:locations-origin', { detail: { lat: lat, lng: lng, label: label } }));
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var zip = (input.value || '').trim();
        if (!/^\d{5}$/.test(zip)) {
          setStatus(copy.zipInvalid, true);
          input.focus();
          return;
        }
        setStatus((copy.lookingUp || '') + zip + '...', false);
        fetch('https://api.zippopotam.us/us/' + zip)
          .then(function (response) {
            if (!response.ok) throw new Error('not found');
            return response.json();
          })
          .then(function (data) {
            var place = data.places && data.places[0];
            if (!place) throw new Error('not found');
            announce(parseFloat(place.latitude), parseFloat(place.longitude), place['place name'] + ' ' + zip);
          })
          .catch(function () {
            setStatus(copy.notFound, true);
          });
      });

      geoBtn.addEventListener('click', function () {
        if (!navigator.geolocation) {
          setStatus(copy.noGeo, true);
          return;
        }
        setStatus(copy.asking, false);
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            announce(pos.coords.latitude, pos.coords.longitude, copy.yourLocation);
          },
          function () {
            setStatus(copy.blocked, true);
          },
          { timeout: 10000 }
        );
      });

      document.addEventListener('drive:locations-reset', function () {
        input.value = '';
        setStatus('', false);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-locations-search]').forEach(initSearch);
    }

    initAll();
    document.addEventListener('shopify:block:select', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-product-addons"] && !Shopify.designMode) return;
  try {
    // Track addon selections (no form field injection)
  document.querySelectorAll('.custom-product-addon').forEach(function(addonEl) {
    var input = addonEl.querySelector('.custom-product-addon__input');
    if (!input) return;

    var img = addonEl.querySelector('.custom-product-addon__image img');
    if (img) { img._defaultSrc = img.src; }

    input.addEventListener('change', function() {
      var isCheckbox = this.type === 'checkbox';
      var variantId = isCheckbox ? this.dataset.variantId : this.value;
      var isActive = (isCheckbox && this.checked) || (!isCheckbox && variantId !== '');

      if (isActive) {
        addonEl.classList.add('selected');
      } else {
        addonEl.classList.remove('selected');
      }

      // Swap addon image to match selected variant
      if (img && !isCheckbox) {
        var selected = this.options[this.selectedIndex];
        var variantImg = selected ? selected.getAttribute('data-image') : null;
        if (variantImg) {
          img.src = variantImg;
          img.srcset = '';
        } else if (img._defaultSrc) {
          img.src = img._defaultSrc;
          img.srcset = '';
        }
      }
    });
  });

  // Intercept form submission to add addons via separate Cart API call
  function getSelectedAddons() {
    var addons = [];
    document.querySelectorAll('.custom-product-addon').forEach(function(addonEl) {
      var input = addonEl.querySelector('.custom-product-addon__input');
      if (!input) return;
      var isCheckbox = input.type === 'checkbox';
      var variantId = isCheckbox ? input.dataset.variantId : input.value;
      var isActive = (isCheckbox && input.checked) || (!isCheckbox && variantId !== '');
      if (isActive && variantId) {
        addons.push({ id: parseInt(variantId, 10), quantity: 1 });
      }
    });
    return addons;
  }

  // Listen for Horizon cart:update events to add addons after main product
  var addonsPending = false;
  document.addEventListener('cart:update', function(e) {
    if (addonsPending) return;
    var detail = e.detail || {};
    var data = detail.data || {};
    // Only act on successful product-form adds
    if (data.source !== 'product-form-component' || data.didError) return;

    var addons = getSelectedAddons();
    if (addons.length === 0) return;

    addonsPending = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: addons })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      // Refresh cart count by fetching updated cart
      return fetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Dispatch cart:update so Horizon refreshes the cart drawer/count
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, data: { source: 'product-addons' } }
      }));
    })
    .finally(function() {
      addonsPending = false;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-product-metafield"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.custom-product-metafield--empty').forEach(function(el) {
    var row = el.closest('accordion-custom');
    if (row) {
      row.style.display = 'none';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-shop-finder"] && !Shopify.designMode) return;
  try {
    (function () {
    var MILES_EARTH = 3958.8;
    var ZIP_URL = 'https://api.zippopotam.us/us/';

    function toRad(d) {
      return (d * Math.PI) / 180;
    }

    function milesBetween(a, b) {
      var dLat = toRad(b.lat - a.lat);
      var dLng = toRad(b.lng - a.lng);
      var s =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * MILES_EARTH * Math.asin(Math.min(1, Math.sqrt(s)));
    }

    function ranked(shops, origin) {
      return shops
        .map(function (shop) {
          return Object.assign({}, shop, { miles: milesBetween(origin, { lat: shop.lat, lng: shop.lng }) });
        })
        .sort(function (a, b) {
          return a.miles - b.miles;
        });
    }

    function formatMiles(n) {
      if (n < 10) return n.toFixed(1);
      return String(Math.round(n));
    }

    function esc(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function cardHtml(shop, showMiles, milesLabel) {
      var miles = '';
      if (showMiles && typeof shop.miles === 'number' && !isNaN(shop.miles)) {
        miles =
          '<span class="drive-shop-finder__miles">' +
          formatMiles(shop.miles) +
          ' ' +
          milesLabel +
          '</span>';
      }
      var sub = shop.blurb
        ? '<p class="drive-shop-finder__sub">' + esc(shop.blurb) + '</p>'
        : '';
      return (
        '<li class="drive-shop-finder__card">' +
        '<i class="icon-map-pin drive-shop-finder__pin" aria-hidden="true"></i>' +
        '<div><p class="drive-shop-finder__city">' +
        (shop.url
          ? '<a class="drive-shop-finder__city-link" href="' + esc(shop.url) + '" data-cta-name="home_finder_shop" data-cta-location="locations" data-destination-type="page">' + esc(shop.city) + '</a>'
          : esc(shop.city)) +
        '</p>' +
        sub +
        miles +
        '</div></li>'
      );
    }

    function init(root) {
      if (!root || root.dataset.shopFinderReady === 'true') return;
      root.dataset.shopFinderReady = 'true';

      var form = root.querySelector('[data-shop-finder-form]');
      var geoBtn = root.querySelector('[data-shop-finder-geo]');
      var statusEl = root.querySelector('[data-shop-finder-status]');
      var cardsEl = root.querySelector('[data-shop-finder-cards]');
      var dataEl = root.querySelector('[data-shop-finder-data]');
      var copyEl = root.querySelector('[data-shop-finder-copy]');
      var zipInput = form ? form.querySelector('input[name="zip"]') : null;
      var milesLabel = root.getAttribute('data-miles-label') || 'miles away';
      var shops = [];
      var copy = {};
      try {
        shops = JSON.parse(dataEl.textContent);
        copy = JSON.parse(copyEl.textContent);
      } catch (e) {
        return;
      }

      function setStatus(msg, isError) {
        statusEl.textContent = msg;
        statusEl.classList.toggle('is-error', !!isError);
        if (zipInput) {
          zipInput.setAttribute('aria-invalid', isError ? 'true' : 'false');
        }
        if (isError) {
          statusEl.setAttribute('role', 'alert');
        } else {
          statusEl.removeAttribute('role');
        }
      }

      function render(list, label) {
        cardsEl.innerHTML = list
          .slice(0, 3)
          .map(function (shop) {
            return cardHtml(shop, true, milesLabel);
          })
          .join('');
        setStatus(label, false);
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var zip = (zipInput.value || '').trim();
          if (!/^\d{5}$/.test(zip)) {
            setStatus(copy.zipInvalid, true);
            return;
          }
          setStatus(copy.lookingUp + zip + '…', false);
          fetch(ZIP_URL + zip)
            .then(function (res) {
              if (!res.ok) throw new Error('not found');
              return res.json();
            })
            .then(function (data) {
              var place = data.places && data.places[0];
              if (!place) throw new Error('not found');
              var origin = {
                lat: parseFloat(place.latitude),
                lng: parseFloat(place.longitude),
              };
              render(
                ranked(shops, origin),
                copy.closestTo + place['place name'] + ', ' + place['state abbreviation'] + ' ' + zip
              );
            })
            .catch(function () {
              setStatus(copy.notFound, true);
            });
        });
      }

      if (geoBtn) {
        geoBtn.addEventListener('click', function () {
          if (!navigator.geolocation) {
            setStatus(copy.noGeo, true);
            return;
          }
          setStatus(copy.asking, false);
          navigator.geolocation.getCurrentPosition(
            function (pos) {
              render(
                ranked(shops, { lat: pos.coords.latitude, lng: pos.coords.longitude }),
                copy.closestHere
              );
            },
            function () {
              setStatus(copy.blocked, true);
            }
          );
        });
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-shop-finder]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
